<template>
  <div>
    <router-view />
  </div>
</template>
<script>
import { mapGetters } from "vuex"

export default {
  computed: {
    ...mapGetters(["getCurrentUser"])
  },
  mounted() {
    if (this.$route.name === "dashboard_my_payments") {
      if (!this.getCurrentUser.landlord.payments_activated) {
        this.$router.push({ name: "dashboard_my_payments_not_enabled" })
      } else {
        this.$router.push({ name: "dashboard_my_payments_accounts" })
      }
    }
  }
}
</script>
